import { combineReducers } from "redux";

import accountsRdxReducer from "features/budget/accounts/rdx/accounts-rdx.reducer";
import budgetReducer from "features/budget/wizard/state/wizard.reducer";
import ownersReducer from "features/budget/owners/rdx/owners.reducer";
import companyStructureRdxReducer from "features/budget/company-structure/rdx/company-structure-rdx.reducer";
import templateReducer from "features/budget/templates/rdx/template.reducer";
import coordinatorUserReducer from "features/coordinator-user/state/coordinator-user.reducer";
import wizardAssignmentReducer from "features/budget/wizard/state/wizard-assignment.reducer";
import scenarioDetailsReducer from "features/overview-budget/rdx/scenario-details.reducer";
import feedbackFormReducer from "common/rdx/feedback/feedback.reducer";

const rootReducer = combineReducers({
  accounts: accountsRdxReducer,
  budget: budgetReducer,
  owners: ownersReducer,
  structure: companyStructureRdxReducer,
  templates: templateReducer,
  users: coordinatorUserReducer,
  wizardAssignments: wizardAssignmentReducer,
  scenarioDetails: scenarioDetailsReducer,
  feedback: feedbackFormReducer,
});

export default rootReducer;
